import React from "react";
// Importamos el badge desde la carpeta bus-routes
import StatusBadge from "../bus-routes/StatusBadge"; 

export default function SidePanel({ title, isConnected, children }) {
  return (
    <div className="routes-panel">
      <div className="routes-header">
        <span className="panel-title">{title}</span>
        {/* 🔥 Solo renderiza el badge si 'isConnected' no es undefined */}
        {isConnected !== undefined && (
            <StatusBadge isConnected={isConnected} />
        )}
      </div>
      <div className="routes-list">
        {children}
      </div>
    </div>
  );
}